// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_It7M4 {
  background-color: var(--_00000033-shadow);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
.loading_YzpfO {
  display: none;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
  height: 3px;
  background: linear-gradient(90deg,
      transparent 0%,
      var(--_16c098-background) 25%,
      var(--_16c098-background) 75%,
      transparent 100%);
  background-size: 200% 100%;
  animation: loading_YzpfO 2s infinite ease-in-out;
  opacity: 0.8;
  -webkit-animation: loading_YzpfO 2s infinite ease-in-out;

  &.active_zpnW8 {
    display: block;
  }
}

@keyframes loading_YzpfO {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

.containerNewContactForm_TAG0i {
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;

  .type_vNsk1 {
    p {
      color: #18181b;
      font-weight: 500;
    }
  }
  .infoSpan_Yw6zf {
    font-size: 13px;
    color: var(--8C90A2-color);
  }
  .sendByMail_AAavn {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .dropdownContainer_JFkVG {
    display: flex;
    gap: 20px;
    justify-content: space-between;
  }
  .dropdownsLeft_P6_VN {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    position: relative;
    .dropdown_eK2Ug {
      flex: 1 1;
      background-color: var(--f4-background);
      width: 100%;
      padding: 10px;
      color: var(--_75-color);
    }
  }
  .note_I_Bsf {
    background-color: var(--_c2f2d3-background);
    border: 1px solid var(--_0000001d-border);
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    .text_JP0IK {
      min-height: 40px;
      height: fit-content;
      max-height: 100px;
      display: flex;
      align-items: center;
      overflow-y: scroll;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    span,
    input {
      background-color: transparent;
      font-family: "Inter", sans-serif;
      font-size: 13px;
    }
    input {
      background-color: var(--_9bd8b1fd-background);
      border: none;
    }
  }
  .tagWhite_mLgL0 {
    background-color: var(--white-background);
  }
  .tagRed_rQWgf {
    background-color: var(--f2c6c2-background);
  }
  .tagOrange_rIm7b {
    background-color: var(--f2cfc2-background);
  }
  .tagYellow_m3v7q {
    background-color: var(--f2e3c2-background);
  }
  .tagGreen_pY4_f {
    background-color: var(--_c2f2d3-background);
  }
  .tagBlue_m9CDo {
    background-color: var(--c2d8f2-background);
  }
  .tagViolet_IlCPn {
    background-color: var(--d7c5f6-background);
  }
  .tagPink_EKjuw {
    background-color: var(--f0c2f2-background);
  }

  .switch_CzPAk {
    position: relative;
    display: inline-block;
    width: 40px;
    margin-top: 7px;
    height: 24px;
  }

  .switch_CzPAk input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider_OzxyJ {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--c-background);
    transition: 0.4s;
    border-radius: 24px;
  }

  .slider_OzxyJ:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: var(--white-background);
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider_OzxyJ {
    background-color: var(--_16c098-background);
  }
  input:checked + .bgBlack_owucm {
    background-color: #000000;
  }

  input:checked + .slider_OzxyJ:before {
    transform: translateX(16px);
  }

.quantityContainer_kq42Y{
  display: flex;
  align-items: center;
  gap: 20px;
  .quantityContent_EAvp1{
    width: 100%;
  }
}
.logoSelectorContainer_LG4EZ{
  display: flex;
  align-items: center;
  gap: 20px;
  >label{
    width: 100%;
  }
}
  .chevronIcon_M00pk {
    height: 10px;
    width: 10px;
  }

  .dropdown_eK2Ug {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .documentIcon_PgTOD {
    color: var(--ff4d4f-color);
  }


  .newContactForm_f5ym0 {
    width: 90%;
    margin: 0 auto;
    height: 100vh;
    overflow: scroll;
    padding-bottom: 100px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
      @media (width<=768px) {
   height: fit-content;

  }
  }
  .payMethodsheader_khABt{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .optionsDetailsBill_pHjWJ{
    display: flex;
    justify-content: end;
  }
  .invoiceInfo_azFJY{
    display: flex;
    gap: 20px;
  }
  .checkboxTextContainer_e6ud_{
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .expensesContainer_AMg31{
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .expenseItem_UezXO{
    display: flex;
    align-items: center;
    gap: 10px;
    input{
      width: 100%;
      margin: 0;
      width: 100%;
      border-radius: 8px;
      padding: 6px;
      border: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
      background-color: var(--f4-background);
      outline: none;
    }
    .expenseQuantity_vupH3{
      width: 20%;
    }
  }
.sectionHeader_eWvYF{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .sectionheaderLeft_DN3TO{
    display: flex;
    align-items: center;
    gap: 10px;
    span{
      font-weight: 500;
      color: #666666;
    }
  }
}
.datesInvoiceHeaderContainer_DZzvx{
  display: flex;
  align-items: center;
  gap: 20px;
  .datesInvoiceHeader_u28q2{
    flex: 1 1;

  }
}
  .sectionContact_cJwHH {
    h3 {
      color: var(--_10a37f-background);
      margin: 20px 0;
    }



    .infoLabel_FCcad,
    .infoLabelIdentification_z8ods {
      background-color: var(--white-color);
      padding: 10px 20px;
      border: 1px solid var(--ececf1-border);
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      gap: 50px;
      textarea[disabled] {
        background-color: transparent;
      }
      textarea {
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 80px !important;
        background-color: var(--f4-background);
        border-radius: 5px;
        font-family: "Inter", sans-serif;
        box-sizing: border-box;
        width: 100%;
        field-sizing: content;
        padding: 8px 4px;
        resize: none;
        max-height: 300px;
      }
    }
    .infoLabelIdentification_z8ods {
      gap: 10px;
    }
  }
}
.newContactContainer_ZWV7Y {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--white-color);
  z-index: 9999;
}
.popupNewContaier_t_Ltq {
  display: flex;
  width: 100%;
  .leftSide_Tz3jU {
    height: calc(100vh - 50px);
    width: 100%;
    max-width: 300px;
  }
  @media (width<=768px) {
    flex-direction: column;
     .leftSide_Tz3jU {
    height: fit-content;
    max-width: 90%;
margin: 0 auto;
padding: 10px;
box-sizing: border-box;
  }

  }
}
.container_fiGfK {
  padding: 20px;
  min-height: 100vh;
  .contactsHeader_zj6F_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .searchContainer_OtchK {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }
}


.containerLeftSide__XGxr {
  max-height: 70vh;
  overflow-y: scroll;
  padding-bottom: 30px;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 20px 10px 0 10px;
  font-family: "Inter", sans-serif;
  max-height: 97vh;
  overflow-y: auto;
  box-sizing: border-box;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.accent_HJb7J {
  accent-color: var(--white-background);
}
.infoContainerWrapper_y7_yo {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  min-height: 45px;
}
.infoContainer_OlmRn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}
.contentContainer_cyUWJ {
  display: flex;
  flex-direction: column;
  gap: 10px;
  &.active_zpnW8 {
    display: flex;
  }
  &.disabled_tBDTe {
    display: none;
  }
}
.contentInput_srNmG {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}
.titleContentInput_wdBY1 {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 8px;
}
.contentInputInputs_dZ52_ {
  display: flex;
  gap: 10px;
  box-sizing: border-box;
  .column_kTs3w {
    flex: 1 1;
  }
}
.wrapperContainer_KASD3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.infoBillContainer_AcEcG{
  border-bottom: 1px solid #11a38138;
  padding: 10px 0;
 }

 .infoBillContainer_AcEcG {
  display: flex;
  flex-direction: column;
  gap: 20px;
  .info_iNq8d{
    p{
      width: 100%;
      display: flex;
      align-items: center;
      svg{
        margin-right: 5px;
      }
    }
  }
  .info_iNq8d {
    display: flex;
    width: 100%;
    span {
      width: fit-content;
      color: #717171;
      font-weight: 400;
    }
  }
  .info_iNq8d {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 19px;

    span {
      color: #717171;
      font-weight: 400;
    }
  }
}

.conceptHeader_iO9pn{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 20px 0;
  gap: 10px;
  h3{
    margin: 0 !important;
  }
  .btnsConcept_ksTXw{
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
}

.conceptContent_XaNGS{
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.inputTextCheckbox_mOslZ{
  margin: 0;
        width: 100%;
        border-radius: 6px;
        padding: 6px;
        border: none;

        background-color: var(--f4-background);
        outline: none;
        width: 30%;
        max-width: 100px;
}
.documentTitle_kXPEf{
  display: flex;
  align-items: center;
  gap: 5px;
  input{
    margin: 0;
    width: 100%;
    border-radius: 8px;
    padding: 6px;
    border: none;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    background-color: var(--f4-background);
    outline: none;
  }
}
.inputTitle_TOe2W{
  margin: 0;
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  border: none;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  background-color: var(--f4-background);
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewBIll/NewBIll.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX;;;;uBAIqB;EACrB,0BAA0B;EAC1B,gDAA0C;EAC1C,YAAY;EACZ,wDAAkD;;EAElD;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;;EAE3B;IACE;MACE,cAAc;MACd,gBAAgB;IAClB;EACF;EACA;IACE,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,aAAa;IACb,SAAS;IACT,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB;MACE,SAAO;MACP,sCAAsC;MACtC,WAAW;MACX,aAAa;MACb,uBAAuB;IACzB;EACF;EACA;IACE,2CAA2C;IAC3C,yCAAyC;IACzC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;MACE,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,qBAAqB;MACrB,wBAAwB;MACxB;QACE,aAAa;MACf;IACF;IACA;;MAEE,6BAA6B;MAC7B,gCAAgC;MAChC,eAAe;IACjB;IACA;MACE,6CAA6C;MAC7C,YAAY;IACd;EACF;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;EAC7C;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,WAAW;EACb;AACF;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,UAAU;IACV,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB;MACE,aAAa;IACf;MACE;GACH,mBAAmB;;EAEpB;EACA;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;MACE,WAAW;MACX,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,sCAAsC;MACtC,aAAa;IACf;IACA;MACE,UAAU;IACZ;EACF;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;MACE,gBAAgB;MAChB,cAAc;IAChB;EACF;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,SAAO;;EAET;AACF;EACE;IACE;MACE,gCAAgC;MAChC,cAAc;IAChB;;;;IAIA;;MAEE,oCAAoC;MACpC,kBAAkB;MAClB,sCAAsC;MACtC,mBAAmB;MACnB,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT;QACE,6BAA6B;MAC/B;MACA;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,2BAA2B;QAC3B,sCAAsC;QACtC,kBAAkB;QAClB,gCAAgC;QAChC,sBAAsB;QACtB,WAAW;QACX,qBAAqB;QACrB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;MACnB;IACF;IACA;MACE,SAAS;IACX;EACF;AACF;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX;IACE,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sBAAsB;KACrB;IACD,mBAAmB;IACnB,cAAc;AAClB,cAAc;AACd,aAAa;AACb,sBAAsB;EACpB;;EAEA;AACF;AACA;EACE,aAAa;EACb,iBAAiB;EACjB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;EACF;AACF;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB;IACE,SAAO;EACT;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB;QACE,iBAAiB;MACnB;IACF;EACF;EACA;IACE,aAAa;IACb,WAAW;IACX;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;IAClB;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET;MACE,cAAc;MACd,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;EACT;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;QACH,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,YAAY;;QAEZ,sCAAsC;QACtC,aAAa;QACb,UAAU;QACV,gBAAgB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sCAAsC;IACtC,aAAa;EACf;AACF;AACA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;AACf","sourcesContent":[".bg {\n  background-color: var(--_00000033-shadow);\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n.loading {\n  display: none;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  z-index: 1;\n  height: 3px;\n  background: linear-gradient(90deg,\n      transparent 0%,\n      var(--_16c098-background) 25%,\n      var(--_16c098-background) 75%,\n      transparent 100%);\n  background-size: 200% 100%;\n  animation: loading 2s infinite ease-in-out;\n  opacity: 0.8;\n  -webkit-animation: loading 2s infinite ease-in-out;\n\n  &.active {\n    display: block;\n  }\n}\n\n@keyframes loading {\n  0% {\n    background-position: -200% 0;\n  }\n\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.containerNewContactForm {\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n\n  .type {\n    p {\n      color: #18181b;\n      font-weight: 500;\n    }\n  }\n  .infoSpan {\n    font-size: 13px;\n    color: var(--8C90A2-color);\n  }\n  .sendByMail {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n  .dropdownContainer {\n    display: flex;\n    gap: 20px;\n    justify-content: space-between;\n  }\n  .dropdownsLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    position: relative;\n    .dropdown {\n      flex: 1;\n      background-color: var(--f4-background);\n      width: 100%;\n      padding: 10px;\n      color: var(--_75-color);\n    }\n  }\n  .note {\n    background-color: var(--_c2f2d3-background);\n    border: 1px solid var(--_0000001d-border);\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    .text {\n      min-height: 40px;\n      height: fit-content;\n      max-height: 100px;\n      display: flex;\n      align-items: center;\n      overflow-y: scroll;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n    span,\n    input {\n      background-color: transparent;\n      font-family: \"Inter\", sans-serif;\n      font-size: 13px;\n    }\n    input {\n      background-color: var(--_9bd8b1fd-background);\n      border: none;\n    }\n  }\n  .tagWhite {\n    background-color: var(--white-background);\n  }\n  .tagRed {\n    background-color: var(--f2c6c2-background);\n  }\n  .tagOrange {\n    background-color: var(--f2cfc2-background);\n  }\n  .tagYellow {\n    background-color: var(--f2e3c2-background);\n  }\n  .tagGreen {\n    background-color: var(--_c2f2d3-background);\n  }\n  .tagBlue {\n    background-color: var(--c2d8f2-background);\n  }\n  .tagViolet {\n    background-color: var(--d7c5f6-background);\n  }\n  .tagPink {\n    background-color: var(--f0c2f2-background);\n  }\n\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    margin-top: 7px;\n    height: 24px;\n  }\n\n  .switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--c-background);\n    transition: 0.4s;\n    border-radius: 24px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 2px;\n    bottom: 2px;\n    background-color: var(--white-background);\n    transition: 0.4s;\n    border-radius: 50%;\n  }\n\n  input:checked + .slider {\n    background-color: var(--_16c098-background);\n  }\n  input:checked + .bgBlack {\n    background-color: #000000;\n  }\n\n  input:checked + .slider:before {\n    transform: translateX(16px);\n  }\n\n.quantityContainer{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  .quantityContent{\n    width: 100%;\n  }\n}\n.logoSelectorContainer{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  >label{\n    width: 100%;\n  }\n}\n  .chevronIcon {\n    height: 10px;\n    width: 10px;\n  }\n\n  .dropdown {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n  }\n\n  .documentIcon {\n    color: var(--ff4d4f-color);\n  }\n\n\n  .newContactForm {\n    width: 90%;\n    margin: 0 auto;\n    height: 100vh;\n    overflow: scroll;\n    padding-bottom: 100px;\n    box-sizing: border-box;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n      @media (width<=768px) {\n   height: fit-content;\n\n  }\n  }\n  .payMethodsheader{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .optionsDetailsBill{\n    display: flex;\n    justify-content: end;\n  }\n  .invoiceInfo{\n    display: flex;\n    gap: 20px;\n  }\n  .checkboxTextContainer{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n  .expensesContainer{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .expenseItem{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    input{\n      width: 100%;\n      margin: 0;\n      width: 100%;\n      border-radius: 8px;\n      padding: 6px;\n      border: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      background-color: var(--f4-background);\n      outline: none;\n    }\n    .expenseQuantity{\n      width: 20%;\n    }\n  }\n.sectionHeader{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .sectionheaderLeft{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    span{\n      font-weight: 500;\n      color: #666666;\n    }\n  }\n}\n.datesInvoiceHeaderContainer{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  .datesInvoiceHeader{\n    flex: 1;\n\n  }\n}\n  .sectionContact {\n    h3 {\n      color: var(--_10a37f-background);\n      margin: 20px 0;\n    }\n\n\n\n    .infoLabel,\n    .infoLabelIdentification {\n      background-color: var(--white-color);\n      padding: 10px 20px;\n      border: 1px solid var(--ececf1-border);\n      border-radius: 16px;\n      display: flex;\n      flex-direction: column;\n      gap: 50px;\n      textarea[disabled] {\n        background-color: transparent;\n      }\n      textarea {\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 80px !important;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        font-family: \"Inter\", sans-serif;\n        box-sizing: border-box;\n        width: 100%;\n        field-sizing: content;\n        padding: 8px 4px;\n        resize: none;\n        max-height: 300px;\n      }\n    }\n    .infoLabelIdentification {\n      gap: 10px;\n    }\n  }\n}\n.newContactContainer {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--white-color);\n  z-index: 9999;\n}\n.popupNewContaier {\n  display: flex;\n  width: 100%;\n  .leftSide {\n    height: calc(100vh - 50px);\n    width: 100%;\n    max-width: 300px;\n  }\n  @media (width<=768px) {\n    flex-direction: column;\n     .leftSide {\n    height: fit-content;\n    max-width: 90%;\nmargin: 0 auto;\npadding: 10px;\nbox-sizing: border-box;\n  }\n\n  }\n}\n.container {\n  padding: 20px;\n  min-height: 100vh;\n  .contactsHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    .searchContainer {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n    }\n  }\n}\n\n\n.containerLeftSide {\n  max-height: 70vh;\n  overflow-y: scroll;\n  padding-bottom: 30px;\n  width: 100%;\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 20px 10px 0 10px;\n  font-family: \"Inter\", sans-serif;\n  max-height: 97vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.accent {\n  accent-color: var(--white-background);\n}\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  min-height: 45px;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  &.active {\n    display: flex;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n.contentInput {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n.titleContentInput {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 8px;\n}\n.contentInputInputs {\n  display: flex;\n  gap: 10px;\n  box-sizing: border-box;\n  .column {\n    flex: 1;\n  }\n}\n.wrapperContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.infoBillContainer{\n  border-bottom: 1px solid #11a38138;\n  padding: 10px 0;\n }\n\n .infoBillContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  .info{\n    p{\n      width: 100%;\n      display: flex;\n      align-items: center;\n      svg{\n        margin-right: 5px;\n      }\n    }\n  }\n  .info {\n    display: flex;\n    width: 100%;\n    span {\n      width: fit-content;\n      color: #717171;\n      font-weight: 400;\n    }\n  }\n  .info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 19px;\n\n    span {\n      color: #717171;\n      font-weight: 400;\n    }\n  }\n}\n\n.conceptHeader{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 20px 0;\n  gap: 10px;\n  h3{\n    margin: 0 !important;\n  }\n  .btnsConcept{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n}\n\n.conceptContent{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.inputTextCheckbox{\n  margin: 0;\n        width: 100%;\n        border-radius: 6px;\n        padding: 6px;\n        border: none;\n\n        background-color: var(--f4-background);\n        outline: none;\n        width: 30%;\n        max-width: 100px;\n}\n.documentTitle{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  input{\n    margin: 0;\n    width: 100%;\n    border-radius: 8px;\n    padding: 6px;\n    border: none;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    background-color: var(--f4-background);\n    outline: none;\n  }\n}\n.inputTitle{\n  margin: 0;\n  width: 100%;\n  border-radius: 8px;\n  padding: 6px;\n  border: none;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  background-color: var(--f4-background);\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_It7M4`,
	"loading": `loading_YzpfO`,
	"active": `active_zpnW8`,
	"containerNewContactForm": `containerNewContactForm_TAG0i`,
	"type": `type_vNsk1`,
	"infoSpan": `infoSpan_Yw6zf`,
	"sendByMail": `sendByMail_AAavn`,
	"dropdownContainer": `dropdownContainer_JFkVG`,
	"dropdownsLeft": `dropdownsLeft_P6_VN`,
	"dropdown": `dropdown_eK2Ug`,
	"note": `note_I_Bsf`,
	"text": `text_JP0IK`,
	"tagWhite": `tagWhite_mLgL0`,
	"tagRed": `tagRed_rQWgf`,
	"tagOrange": `tagOrange_rIm7b`,
	"tagYellow": `tagYellow_m3v7q`,
	"tagGreen": `tagGreen_pY4_f`,
	"tagBlue": `tagBlue_m9CDo`,
	"tagViolet": `tagViolet_IlCPn`,
	"tagPink": `tagPink_EKjuw`,
	"switch": `switch_CzPAk`,
	"slider": `slider_OzxyJ`,
	"bgBlack": `bgBlack_owucm`,
	"quantityContainer": `quantityContainer_kq42Y`,
	"quantityContent": `quantityContent_EAvp1`,
	"logoSelectorContainer": `logoSelectorContainer_LG4EZ`,
	"chevronIcon": `chevronIcon_M00pk`,
	"documentIcon": `documentIcon_PgTOD`,
	"newContactForm": `newContactForm_f5ym0`,
	"payMethodsheader": `payMethodsheader_khABt`,
	"optionsDetailsBill": `optionsDetailsBill_pHjWJ`,
	"invoiceInfo": `invoiceInfo_azFJY`,
	"checkboxTextContainer": `checkboxTextContainer_e6ud_`,
	"expensesContainer": `expensesContainer_AMg31`,
	"expenseItem": `expenseItem_UezXO`,
	"expenseQuantity": `expenseQuantity_vupH3`,
	"sectionHeader": `sectionHeader_eWvYF`,
	"sectionheaderLeft": `sectionheaderLeft_DN3TO`,
	"datesInvoiceHeaderContainer": `datesInvoiceHeaderContainer_DZzvx`,
	"datesInvoiceHeader": `datesInvoiceHeader_u28q2`,
	"sectionContact": `sectionContact_cJwHH`,
	"infoLabel": `infoLabel_FCcad`,
	"infoLabelIdentification": `infoLabelIdentification_z8ods`,
	"newContactContainer": `newContactContainer_ZWV7Y`,
	"popupNewContaier": `popupNewContaier_t_Ltq`,
	"leftSide": `leftSide_Tz3jU`,
	"container": `container_fiGfK`,
	"contactsHeader": `contactsHeader_zj6F_`,
	"searchContainer": `searchContainer_OtchK`,
	"containerLeftSide": `containerLeftSide__XGxr`,
	"accent": `accent_HJb7J`,
	"infoContainerWrapper": `infoContainerWrapper_y7_yo`,
	"infoContainer": `infoContainer_OlmRn`,
	"contentContainer": `contentContainer_cyUWJ`,
	"disabled": `disabled_tBDTe`,
	"contentInput": `contentInput_srNmG`,
	"titleContentInput": `titleContentInput_wdBY1`,
	"contentInputInputs": `contentInputInputs_dZ52_`,
	"column": `column_kTs3w`,
	"wrapperContainer": `wrapperContainer_KASD3`,
	"infoBillContainer": `infoBillContainer_AcEcG`,
	"info": `info_iNq8d`,
	"conceptHeader": `conceptHeader_iO9pn`,
	"btnsConcept": `btnsConcept_ksTXw`,
	"conceptContent": `conceptContent_XaNGS`,
	"inputTextCheckbox": `inputTextCheckbox_mOslZ`,
	"documentTitle": `documentTitle_kXPEf`,
	"inputTitle": `inputTitle_TOe2W`
};
export default ___CSS_LOADER_EXPORT___;
